import api from '../../plugins/api';

// origin â Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾ Ð½Ð° Ð²ÐµÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑ: Ð² ÐÐ¸ÑÑÐ¸ÐºÑÐµ ÑÐ°ÐºÐ¾Ð³Ð¾ Ð¿Ð¾Ð»Ñ Ð½ÐµÑ Ð²Ð¾Ð¾Ð±ÑÐµ.
// ÐÐµ Ð¿ÐµÑÐµÐ´Ð°Ð»Ð¸ â ÑÑÑÐ¾ÐºÐ¸ ÑÐµÐ´ÑÑ Ð² ÑÑÑÐ½ÑÑ Ð¿ÑÐ°Ð²ÐºÑ, ÐºÐ°Ðº Ð¿ÑÐ¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐµ Ð±Ð¸ÑÑÐ¸ÐºÑÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ Excel
const startBitrixImport = (marks, origin) =>
  api.post('/api/crm/cars/bitrixStock/start', { marks, origin });

export default startBitrixImport;
